import 'mdb-ui-kit';

import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';

import $ from 'jquery';

import localeEn from 'air-datepicker/locale/en';
import localeHu from 'air-datepicker/locale/hu';

let locale = localeHu;
if ($('html').attr('lang') !== 'hu') {
    locale = localeEn;
}

new AirDatepicker('.date-picker', {
    dateFormat: 'yyyy.MM.dd',
    locale: locale
});
